import { queryClient } from './queryClient';
import { disconnectSocket } from './socket';
import { AUTH_STORAGE_KEY, useAuthStore } from '../store/authStore';
import { useNotificationStore } from '../store/notificationStore';

const AUTH_STORAGE_KEYS = [AUTH_STORAGE_KEY, 'lum-csrf-token'];
const EXPLICIT_LOGOUT_STORAGE_KEY = 'lum-explicit-logout';

export function markExplicitLogout(): void {
  if (typeof window !== 'undefined') window.sessionStorage.setItem(EXPLICIT_LOGOUT_STORAGE_KEY, 'true');
}

export function clearExplicitLogout(): void {
  if (typeof window !== 'undefined') window.sessionStorage.removeItem(EXPLICIT_LOGOUT_STORAGE_KEY);
}

export function hasExplicitLogout(): boolean {
  return typeof window !== 'undefined' && window.sessionStorage.getItem(EXPLICIT_LOGOUT_STORAGE_KEY) === 'true';
}

export function clearPersistedAuthStorage(): void {
  if (typeof window === 'undefined') return;

  for (const key of AUTH_STORAGE_KEYS) {
    window.localStorage.removeItem(key);
    window.sessionStorage.removeItem(key);
  }
}

export function clearClientSessionState(): void {
  useAuthStore.getState().clearAuth();
  useNotificationStore.getState().clearNotifications();
  disconnectSocket();
  queryClient.clear();
  clearPersistedAuthStorage();
}
